import React, { useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { POPUP_DURATION_DELAY } from './popUpStyles';

/**
 * - open - boolean (Snackbar state)
 * - handleClose (Snackbar close handler function)
 * - severity (Snackbar alert state)
 * - message (Snackbar message)
 * @returns Snackbar UI
 */
export const CustomSnackbar = ({ open, handleClose, severity = 'warning', message = 'Inserisci i dati mancanti' }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={POPUP_DURATION_DELAY}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

/**
 * @param {Function} initialState
 * @returns Snackbar handler functions
 */
export const CreateSnackbarFunctions = (initialState) => {
  const [open, setOpen] = useState(initialState);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return { open, handleOpen, handleClose };
};
